
export { BalanceInfiniteIcon } from "./BalanceInfiniteIcon"